module.exports = __webpack_public_path__ + "img/plus-icon-gray.97df8449.svg";